import React from "react";

export default class StepsToMoving extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flagSteps: 1
        }
    }

    setStepNav(val) {
        this.setState({
            flagSteps: val
        })
    };

    onClick = (event) => {
        event.preventDefault();
    };

    openIntercom = () => {
        // window.Intercom('show');
    };

    render() {

        const { lang } = this.props;

        return (
            <div className="s-index-steps-road">
                <div className="container">
                    <div className="title">
                        <h2 className="s-index__title t-left">{lang.StepsRoad_title}</h2>

                        <ul className="list-unstyled clearfix type-list">
                            <li className={this.state.flagSteps === 1 ? "active" : null} onClick={this.setStepNav.bind(this, 1)}><span onClick={this.onClick}>{lang.StepsRoad_list_tab_1}</span></li>
                            <li className={this.state.flagSteps === 2 ? "active" : null} onClick={this.setStepNav.bind(this, 2)}><span onClick={this.onClick}>{lang.StepsRoad_list_tab_2}</span></li>
                            <li className={this.state.flagSteps === 3 ? "active" : null} onClick={this.setStepNav.bind(this, 3)}><span onClick={this.onClick}>{lang.StepsRoad_list_tab_3}</span></li>
                        </ul>
                    </div>

                    <div className="index-steps-road-cnt">

                        {this.state.flagSteps === 1 ? (
                            <div className="index-steps-road-item active">
                                <div className="index-question-list t-small row">
                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_1_title_1}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_1_desc_1}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_1_title_2}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_1_desc_2}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_1_title_3}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_1_desc_3}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {this.state.flagSteps === 2 ? (
                            <div className="index-steps-road-item active">
                                <div className="index-question-list t-small row">
                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_2_title_1}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_2_desc_1}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_2_title_2}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_2_desc_2}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_2_title_3}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_2_desc_3}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {this.state.flagSteps === 3 ? (
                            <div className="index-steps-road-item active">
                                <div className="index-question-list t-small row">
                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_3_title_1}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_3_desc_1}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_3_title_2}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_3_desc_2}</p>
                                        </div>
                                    </div>

                                    <div className="index-question-list-item t-small col-4">
                                        <div className="inner">
                                            <h4 className="title">{lang.StepsRoad_list_item_3_title_3}</h4>
                                            <p className="desc">{lang.StepsRoad_list_item_3_desc_3}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <div className="more-btn">
                            <button type="button" className="btn btn-primary" onClick={this.openIntercom}>{lang.StepsRoad_more_btn}<i className="icon"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}